export default "__VITE_ASSET__fc682f90__"